import Vue from 'vue/dist/vue.esm.js';
import FilterUtility from "../utility/FilterUtility";

Vue.component('mobile-filter', {
    template: '#mobile-filter',
    delimiters: ['[[', ']]'],
    props: {
        brands: {
            required: true,
            type: Array,
        },
        productLines: {
            required: true,
            type: Array,
        },
        features: {
            required: true,
            type: [ Object, Array ],
        },
    },
    data()
    {
       return {
           selectedFilters: {
               brands: [],
               productLines: [],
               features: {}
           },
           isEditingFilter: false,
           editedFilter: {
               title: "",
               slug: "",
               options: [],
           },
           search: "",
       };
    },
    mounted()
    {
        EventManager.listen('mobile-filter-open', this.HandleMobileFilterOpen);
    },
    methods: {
        HandleMobileFilterOpen()
        {
            this.selectedFilters = FilterUtility.GetSelectedFilters();

            this.$forceUpdate();

            this.Open();
        },
        HandleCloseClick()
        {
            this.Close();
        },
        HandleClearAllClick()
        {
            this.selectedFilters = { brands: [], productLines: [], features: {} };

            this.$forceUpdate();
        },
        HandleClearEditedFilterClick()
        {
            if(this.editedFilter.slug === "_brands")
            {
                this.selectedFilters.brands = [];
            }
            else if(this.editedFilter.slug === "_product_lines")
            {
                this.selectedFilters.productLines = [];
            }
            else
            {
                delete this.selectedFilters.features[this.editedFilter.slug];
            }

            this.$forceUpdate();
        },
        HandleBrandsClick()
        {
            this.isEditingFilter = true;

            this.editedFilter = {
                title: '',
                slug: "_brands",
                options: this.brands
            };

            this.$forceUpdate();
        },
        HandleProductLinesClick()
        {
            this.isEditingFilter = true;

            this.editedFilter = {
                title: '',
                slug: "_product_lines",
                options: this.productLines
            };

            this.$forceUpdate();
        },
        HandleFeatureClick(featureSlug)
        {
            let feature = Object.values(this.features).find(f => f.slug === featureSlug);

            if(feature == null)
            {
                return;
            }

            this.isEditingFilter = true;

            this.editedFilter = {
                title: feature.name,
                slug: feature.slug,
                options: feature.values
            };

            this.$forceUpdate();
        },
        HandleBackClick()
        {
            this.isEditingFilter = false;
        },
        HandleApplyClick()
        {
            FilterUtility.ApplySelectedFilters(this.selectedFilters);
        },
        HandleOptionClick(featureSlug, value)
        {
            if(featureSlug === "_brands")
            {
                this.Toggle(this.selectedFilters.brands, value);
            }
            else if(featureSlug === "_product_lines")
            {
                this.Toggle(this.selectedFilters.productLines, value);
            }
            else
            {
                if(!this.selectedFilters.features[featureSlug])
                {
                    this.selectedFilters.features[featureSlug] = [];
                }

                this.Toggle(this.selectedFilters.features[featureSlug], value);

                if(this.selectedFilters.features[featureSlug].length === 0)
                {
                    delete this.selectedFilters.features[featureSlug];
                }
            }

            this.$forceUpdate();
        },
        Toggle(arr, value)
        {
            if(arr == null)
            {
                return;
            }

            // Use loose comparison to find the index (handles both string and integer IDs)
            let index = arr.findIndex(item => item == value);

            if(index !== -1)
            {
                arr.splice(index, 1);
            }
            else
            {
                arr.push(value);
            }
        },
        IsOptionSelected(featureSlug, value)
        {
            if(featureSlug === "_brands")
            {
                // Use loose comparison to handle both string and integer IDs
                return this.selectedFilters.brands.some(id => id == value);
            }
            else if(featureSlug === "_product_lines")
            {
                // Use loose comparison to handle both string and integer IDs
                return this.selectedFilters.productLines.some(id => id == value);
            }
            else
            {
                return this.selectedFilters.features[featureSlug] != null && this.selectedFilters.features[featureSlug].some(id => id == value);
            }
        },
        HandleRemoveBrands()
        {
            this.selectedFilters.brands = [];

            this.$forceUpdate();
        },
        HandleRemoveProductLines()
        {
            this.selectedFilters.productLines = [];

            this.$forceUpdate();
        },
        HandleRemoveFeature(featureSlug)
        {
            delete this.selectedFilters.features[featureSlug];

            this.$forceUpdate();
        },
        Open()
        {
            document.body.classList.add('m-filter-open');
        },
        Close()
        {
            document.body.classList.remove('m-filter-open');
        }
    }
});